



























































import Vue from 'vue';
import { ALForm } from '@/common/component.types';
import { AxiosError } from 'axios';

import {
  IPriceSnapshot,
  PriceSnapshot,
  PriceSnapshotFieldError
} from '@/models';
import { mapActions } from 'vuex';
import { ErrorManager } from '@/models/error';
import { cloneDeep } from 'lodash';
import { diffDeep } from '@/utils/helpers';
import ErrorAlert from '../common/ErrorAlert.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    form: ALForm;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  components: { ErrorAlert, ALDialog },
  name: 'ItemFormDialog',

  data: () => ({
    isFormValid: false,
    dialog: false,
    isEdit: false,
    loading: false,
    errorMessage: '',
    fieldError: new PriceSnapshotFieldError(),
    detailErrorMessage: '',
    priceSnapshot: new PriceSnapshot() as IPriceSnapshot,
    priceSnapshotOriginalCopy: new PriceSnapshot() as IPriceSnapshot,
    descriptionRule: [(v: string) => !!v || 'Description is required']
  }),

  computed: {
    formTitle() {
      return `${this.isEdit ? 'Edit' : 'New'} Pricing Snapshot`;
    }
  },

  methods: {
    ...mapActions({
      createPriceSnapshot: 'priceSnapshot/createPriceSnapshot',
      updatePriceSnapshot: 'priceSnapshot/updatePriceSnapshot'
    }),

    resetFormValidation(): void {
      if (this.$refs.form) {
        return this.$refs.form.resetValidation();
      }
    },

    validateForm(): boolean {
      let valid = false;
      if (this.$refs.form) {
        valid = this.$refs.form.validate();
      }
      return valid;
    },

    open(item = new PriceSnapshot(), isEdit = false) {
      this.priceSnapshotOriginalCopy = item;
      this.priceSnapshot = cloneDeep(item);
      this.isEdit = isEdit;
      this.clearAllErrors();
      this.dialog = true;

      this.resetFormValidation();
    },

    close() {
      this.dialog = false;
    },

    clearAllErrors(): void {
      this.fieldError.clearErrors();
      this.detailErrorMessage = '';
      this.errorMessage = '';
    },

    async savePriceSnapshot() {
      if (this.validateForm()) {
        this.loading = true;
        this.clearAllErrors();

        try {
          if (this.isEdit) {
            const itemDelta = diffDeep(
              this.priceSnapshot,
              this.priceSnapshotOriginalCopy,
              true
            );
            await this.updatePriceSnapshot(itemDelta);
          } else {
            await this.createPriceSnapshot(this.priceSnapshot);
          }
          this.close();
        } catch (err) {
          const error = err as AxiosError;
          this.errorMessage = ErrorManager.extractApiError(error);
          if (error.response) {
            // client received an error response that falls out of range 2xx
            if (
              PriceSnapshotFieldError.isPriceSnapshotFieldError(
                error.response.data
              )
            ) {
              this.fieldError = new PriceSnapshotFieldError(
                error.response.data
              );
            } else if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
        } finally {
          this.loading = false;
        }
      }
    }
  }
});
